module.exports = __webpack_public_path__ + "img/uparrow.e2f8f8f3.svg";